exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{background:#efefef}.login-form .form-control{border:0;height:auto;padding:0}.login-form .btn.btn-primary{border-radius:50px!important;display:block;font-weight:600;height:auto;padding:.5em 3em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a7a04b0","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/changePwd.vue
// module id = cxPt
// module chunks = 1